import { toast } from 'react-toastify';

const defaultOptions = {
  position: "top-center",
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  autoClose: 3000,
};

export const notificationService = {
  success: (message, options = {}) => {
    toast.success(message, {
      ...defaultOptions,
      className: 'bg-success text-white',
      ...options
    });
  },

  error: (message, options = {}) => {
    toast.error(message, {
      ...defaultOptions,
      className: 'bg-danger text-white',
      closeOnClick: false,
      ...options
    });
  },

  info: (message, options = {}) => {
    toast.info(message, {
      ...defaultOptions,
      className: 'bg-info text-white',
      hideProgressBar: false,
      ...options
    });
  },

  custom: (content, options = {}) => {
    return toast(content, {
      ...defaultOptions,
      ...options
    });
  },

  dismissAll: () => {
    toast.dismiss();
  },
};
